import type { AgentLogLine } from '../types.js';

/**
 * Drop fully empty lines from the edges of a log run while preserving interior
 * blanks, which carry meaningful spacing from the agent's stdout or stderr.
 */
export function trimEmptyLogEdges(lines: readonly AgentLogLine[]): AgentLogLine[] {
  let start = 0;
  let end = lines.length;
  while (start < end && lines[start].text.trim().length === 0) start++;
  while (end > start && lines[end - 1].text.trim().length === 0) end--;
  return lines.slice(start, end);
}
